import { CardDistributionType, TileCornerBuildingType, TileEdgeType } from '@colonist/game-states';
import { robberSkinController } from '../UIGameRobberSkinController.ts';
import { CARD_IMAGES, CARD_POPUP_BODY, CARD_TIP_TITLE } from '@colonist/ui-game';
import { UIImagePathController } from '../../UIEnums.ts';
import TileGold from '@static/images/generated_tile_gold.svg';
import IconAqueduct from '@static/images/icon_aqueduct.svg';
import IconBarbarianShip from '@static/images/icon_barbarian_ship.svg';
export class UIGamePopupInformationView {
    static getPopupInformationForCardData(cardData) {
        const newPopupInformation = {
            imagePath: CARD_IMAGES[cardData.cardEnum],
            title: CARD_TIP_TITLE[cardData.cardEnum],
            body: CARD_POPUP_BODY[cardData.cardEnum]
        };
        return newPopupInformation;
    }
    static getPopupInformationForPendingDistributions(pendingDistributionSelectFormat) {
        switch(pendingDistributionSelectFormat.selectionType){
            case CardDistributionType.ResourceTile:
            case CardDistributionType.StartingResources:
                return undefined;
            case CardDistributionType.GoldTile:
                return UIGamePopupInformationView.getPopupInformationForGoldTileDistribution(pendingDistributionSelectFormat);
            case CardDistributionType.Aqueduct:
                return UIGamePopupInformationView.getPopupInformationForAqueductDistribution(pendingDistributionSelectFormat);
            case CardDistributionType.BarbarianProgressCard:
                return UIGamePopupInformationView.getPopupInformationForBarbarianProgressCardDistribution(pendingDistributionSelectFormat);
        }
    }
    static getPopupInformationForGoldTileDistribution(pendingDistributionSelectFormat) {
        const amountToSelect = pendingDistributionSelectFormat.selectCardFormat.amountOfCardsToSelect;
        const popupInformation = {
            imagePath: TileGold,
            title: {
                key: 'strings:game.distribution.goldTile'
            },
            body: {
                key: 'strings:game.distribution.body',
                options: {
                    count: amountToSelect
                }
            }
        };
        return popupInformation;
    }
    static getPopupInformationForAqueductDistribution(pendingDistributionSelectFormat) {
        const amountToSelect = pendingDistributionSelectFormat.selectCardFormat.amountOfCardsToSelect;
        const popupInformation = {
            imagePath: IconAqueduct,
            title: {
                key: 'strings:game.distribution.aqueduct'
            },
            body: {
                key: 'strings:game.distribution.body',
                options: {
                    count: amountToSelect
                }
            }
        };
        return popupInformation;
    }
    static getPopupInformationForBarbarianProgressCardDistribution(pendingDistributionSelectFormat) {
        const popupInformation = {
            imagePath: IconBarbarianShip,
            title: {
                key: 'strings:game.distribution.barbarianProgressCard.title'
            },
            body: {
                key: 'strings:game.distribution.barbarianProgressCard.body'
            }
        };
        return popupInformation;
    }
    static getPopupInformationForPlayerRolledSeven(uiGameManager) {
        const popupInformation = {
            imagePath: robberSkinController.getRobberSkin(),
            title: {
                key: 'strings:game.tips.robber.title'
            },
            body: {
                key: 'strings:game.prompts.playerRolledSeven'
            }
        };
        return popupInformation;
    }
    static getPopupInformationForInitialRoadPlacement(uiGameManager) {
        const imagePath = UIImagePathController.roadsByColor[uiGameManager.gameController.myColor];
        const isFirstInitialRoad = uiGameManager.gameController.mapValidator.tileState.getPlacedEdgePieceCountForPlayer(TileEdgeType.Road, uiGameManager.gameController.myColor) == 0;
        if (isFirstInitialRoad) {
            return {
                imagePath: imagePath,
                title: {
                    key: 'strings:game.prompts.initialPlacements.firstRoad.title'
                },
                body: {
                    key: 'strings:game.prompts.initialPlacements.firstRoad.body'
                }
            };
        }
        return {
            imagePath: imagePath,
            title: {
                key: 'strings:game.prompts.initialPlacements.secondRoad.title'
            },
            body: {
                key: 'strings:game.prompts.initialPlacements.secondRoad.body'
            }
        };
    }
    static getPopupInformationForInitialSettlementPlacement(uiGameManager) {
        const imagePath = UIImagePathController.settlementsByColor[uiGameManager.gameController.myColor];
        const placedSettlementAmount = uiGameManager.gameController.mapValidator.tileState.getPlacedCornerBuildingCountForPlayer(TileCornerBuildingType.Settlement, uiGameManager.gameController.myColor);
        const isFirstInitialSettlement = placedSettlementAmount == 0;
        if (isFirstInitialSettlement) {
            return {
                imagePath: imagePath,
                title: {
                    key: 'strings:game.prompts.initialPlacements.firstSettlement.title'
                },
                body: {
                    key: 'strings:game.prompts.initialPlacements.firstSettlement.body'
                }
            };
        }
        return {
            imagePath: imagePath,
            title: {
                key: 'strings:game.prompts.initialPlacements.secondSettlement.title'
            },
            body: {
                key: 'strings:game.prompts.initialPlacements.secondSettlement.body'
            }
        };
    }
}
